import { array, literal, minLength, object, pipe, string, variant } from "valibot";
import { MAX_CHARACTERS_SM } from "../../constants";
import {
  fieldValueReferenceOfTypes,
  metaVariableValueReferenceOfTypes,
  variableValueReferenceOfTypes,
} from "./references";
import { email, errorTranslation } from "./base";
import { keyFromSelector } from "i18next";

export const recipient = () =>
  variant("type", [
    object({
      type: literal("literal"),
      value: email(MAX_CHARACTERS_SM),
    }),
    object({
      type: literal("field"),
      value: fieldValueReferenceOfTypes(["email", "lookup", "radio", "search"]),
    }),
    object({
      type: literal("variable"),
      value: variableValueReferenceOfTypes(["string"]),
    }),
    object({
      type: literal("metaVariable"),
      value: metaVariableValueReferenceOfTypes(["sys.user"]),
    }),
    object({
      type: literal("unknown"),
      value: string(),
    }),
  ]);

export const requireRecipients = () =>
  pipe(array(recipient()), minLength(1, errorTranslation(keyFromSelector(($) => $.VALIDATION_RECIPIENTS_MIN))));
